import { ChallengeIcon, ChallengeIconGlyph } from "./challenge-icon";
export var TrendIcon = ChallengeIcon;
export var TrendIconGlyph = ChallengeIconGlyph;